import type { wasticApiContract } from '@packages/contracts';
import type { ClientArgs, ClientInferResponseBody } from '@ts-rest/core';
import type { UseQueryOptions } from '@ts-rest/react-query/v5';
import { CART_QUERY_KEYS } from './cart.query-keys';

export type GuestCartRoute = typeof wasticApiContract.web.guestCart;
export type GetGuestCartRoute = GuestCartRoute['get'];
export type GetGuestCartResponse = ClientInferResponseBody<GetGuestCartRoute, 200>['data'];

export type GetGuestCartQueryOptions = UseQueryOptions<
	GetGuestCartRoute,
	ClientArgs,
	GetGuestCartResponse
>;
export function createGetGuestCartQueryOptions(enabled: boolean): GetGuestCartQueryOptions {
	return {
		queryKey:             CART_QUERY_KEYS.GUEST(),
		select:               data => data.body.data,
		refetchOnWindowFocus: false,
		enabled,
		retry:                (retryAmount, error) => {
			const { status } = error as unknown as { status: number };

			if (status === 404) return false;

			return retryAmount < 3;
		},
	};
}

export type MemberCartRoute = typeof wasticApiContract.web.cart;
export type GetMemberCartRoute = MemberCartRoute['get'];
export type GetMemberCartResponse = ClientInferResponseBody<GetMemberCartRoute, 200>['data'];

export type GetMemberCartQueryOptions = UseQueryOptions<
	GetMemberCartRoute,
	ClientArgs,
	GetMemberCartResponse
>;
export function createGetMemberCartQueryOptions(
	enabled: boolean, promotionId: string | null | undefined,
):GetMemberCartQueryOptions {
	return {
		queryKey:             CART_QUERY_KEYS.MEMBER({ promotionId }),
		queryData:            promotionId ? { query: { promotionId } } : undefined,
		select:               data => data.body.data,
		refetchOnWindowFocus: false,
		enabled,
		retry:                (retryAmount, error) => {
			const { status } = error as unknown as { status: number };

			if (status === 404 || status === 401) return false;

			return retryAmount < 3;
		},
	};
}